import { useAuth } from "@/contexts/AuthContext";
import { queryConfirmationNames } from "@/services/EventService";
import axios from "axios";
import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { CircleDashed, CircleDashedCheck, MessageCircleCheck, MessageCircleX } from "lucide-react";
import { useNotify } from "@/contexts/NotifyContext";
import { NavBack } from "../layout/Menu/NavBack";
import { ConfirmationStatus } from "iasma-datatypes";

type dataType = {
    id: number;
    year: number;
    name: string;
    classes: string;
    confirmation: ConfirmationStatus;
}

export function confirmationIcon(confirmation: ConfirmationStatus) {
    switch (confirmation) {
        case ConfirmationStatus.Hadir: return <div className="flex flex-row items-center gap-1 text-nowrap"><MessageCircleCheck size={14} />insyAllah hadir</div>
        case ConfirmationStatus.MungkinHadir: return <div className="flex flex-row items-center gap-1 text-nowrap"><CircleDashedCheck size={14} />mungkin hadir</div>
        case ConfirmationStatus.TidakHadir: return <div className="flex flex-row items-center gap-1 text-nowrap"><MessageCircleX size={14} />tidak hadir</div>
        default: return <div className="flex flex-row items-center gap-1 text-nowrap"><CircleDashed size={14} />senyap saja</div>
    }
}


export function ChartConfirmationNames({ eventId, year, callback }: { 
    eventId: number;
    year: number;
    callback: () => void;
}) {
    const { setToken } = useAuth();
    const { setNotify } = useNotify();
    const [data, setData] = useState<dataType[]>([]);

    useEffect(() => {
        setNotify(null);
        setToken(axios);
        queryConfirmationNames(eventId, Number(year)).then(
            (recs: any) => {
                // console.log(recs);
                let result: dataType[] = [];
                for (let i = 0; i < recs.length; i++) {
                    const rec = recs[i];
                    result.push({
                        id: rec.Id,
                        year: rec.Graduation,
                        name: rec.Name,
                        classes: rec.Classes,
                        confirmation: rec.Confirmation
                    });
                }
                setData(result);
            }, (error: any) => {
                setNotify({ title: "Konfirmasi Gagal", error, severity: 'error' });
            }
        )
    }, [year]);

    return (
        <div className="flex flex-col gap-2 items-center justify-center">
        <NavBack />
            <h4 className="text-center font-bold">Konfirmasi Kehadiran Angkatan {year}</h4>
            <div className="max-w-100">
                <div className="max-h-100 overflow-auto border">
                    <Table className="">
                        <TableHeader>
                            <TableRow>
                                <TableHead className="text-left">Nama</TableHead>
                                <TableHead className="text-right" >Konfirmasi</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {data.map((rec, i) => (
                                <TableRow key={i}>
                                    <TableCell className="text-left p-1">{rec.name} </TableCell>
                                    <TableCell className="text-center p-1">{confirmationIcon(rec.confirmation)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <div className="mt-3 w-full">
                    <button type="button" onClick={callback} className="w-full rounded-md mb-2.5 p-2.5 bg-[#f8ad3c] text-white cursor-pointer opacity-80 hover:opacity-100">
                        Kembali
                    </button>
                </div>
            </div>
        </div>
    )
}